module.exports = __webpack_public_path__ + "img/IMG_1156_L.566ab804.webp";